type VehicleIdentityLike = {
  type?: string | null;
  vehicle_type?: string | null;
  brand?: string | null;
  model?: string | null;
  color?: string | null;
  vehicle_color?: string | null;
};

type VehicleColorMeta = {
  label: string;
  swatch: string | null;
};

const VEHICLE_COLOR_SWATCHES: Record<string, string> = {
  blanco: '#f8fafc',
  negro: '#111827',
  gris: '#94a3b8',
  plata: '#cbd5e1',
  azul: '#3b82f6',
  rojo: '#ef4444',
  verde: '#10b981',
  amarillo: '#eab308',
  naranja: '#f97316',
  cafe: '#92400e',
  marron: '#92400e',
  beige: '#d6b892',
  crema: '#f5e6c8',
  morado: '#8b5cf6',
  violeta: '#8b5cf6',
  rosa: '#ec4899',
  white: '#f8fafc',
  black: '#111827',
  gray: '#94a3b8',
  grey: '#94a3b8',
  silver: '#cbd5e1',
  blue: '#3b82f6',
  red: '#ef4444',
  green: '#10b981',
  yellow: '#eab308',
  orange: '#f97316',
  brown: '#92400e',
  purple: '#8b5cf6',
  pink: '#ec4899',
};

const NON_VEHICLE_TYPE_VALUES = new Set([
  'vehicle',
  'destination',
  'poi',
  'poi_caseta',
  'poi_gasolinera',
  'search_area',
  'risk_zone',
]);

function cleanText(value: string | null | undefined): string | null {
  if (value == null) return null;
  const text = String(value).trim();
  return text ? text : null;
}

function normalizeColor(value: string): string {
  return value
    .toLowerCase()
    .trim()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');
}

export function getVehicleTypeLabel(vehicle: VehicleIdentityLike): string | null {
  const label = cleanText(vehicle.vehicle_type ?? vehicle.type);
  if (!label) return null;
  return NON_VEHICLE_TYPE_VALUES.has(label.toLowerCase()) ? null : label;
}

export function getVehicleColorLabel(vehicle: VehicleIdentityLike): string | null {
  return cleanText(vehicle.vehicle_color ?? vehicle.color);
}

export function getVehicleBrandModel(vehicle: VehicleIdentityLike): string | null {
  const parts = [cleanText(vehicle.brand), cleanText(vehicle.model)].filter(Boolean);
  return parts.length > 0 ? parts.join(' ') : null;
}

export function getVehicleDescriptor(vehicle: VehicleIdentityLike): string | null {
  const parts = [getVehicleTypeLabel(vehicle), getVehicleBrandModel(vehicle)].filter(Boolean);
  return parts.length > 0 ? parts.join(' · ') : null;
}

export function getVehicleColorMeta(vehicle: VehicleIdentityLike): VehicleColorMeta | null {
  const label = getVehicleColorLabel(vehicle);
  if (!label) return null;

  const normalized = normalizeColor(label);
  const swatch = normalized.startsWith('#')
    ? normalized
    : VEHICLE_COLOR_SWATCHES[normalized] || null;

  return { label, swatch };
}
